import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

/**
 * Universal back button — works in 2 modes:
 *
 *  1. <BackButton />                       → navigate(-1)  (browser history)
 *  2. <BackButton onClick={() => ...} />   → custom action (close modal, go to step, etc.)
 *
 * Visible on every private view header, dialog header, and public booking step.
 */
export function BackButton({ onClick, label, className = "", testId = "back-btn", variant = "default" }) {
  const navigate = useNavigate();
  const handle = (e) => {
    e?.preventDefault?.();
    if (onClick) onClick();
    else navigate(-1);
  };
  const baseLight = "inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium uppercase tracking-wider rounded-sm border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-300 transition-colors";
  const baseDark  = "inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium uppercase tracking-wider rounded-sm border border-[var(--ag-border)] bg-transparent text-[var(--ag-text-dim)] hover:text-white hover:border-[var(--ag-gold)]/40 hover:bg-[var(--ag-midnight-soft)] transition-colors";
  const base = variant === "light" ? baseLight : baseDark;
  return (
    <button type="button" onClick={handle} className={`${base} ${className}`} data-testid={testId} aria-label={label || "Volver"}>
      <ArrowLeft size={13} weight="bold" /> {label || "Atrás"}
    </button>
  );
}

export default BackButton;
